/**
 * Color palette and color helpers for the Buckets & Cups visualizer. Extracted
 * from the component so the rendering file stays focused on layout/logic and so
 * `colorForItemType`/`rankColor` can be unit tested in isolation.
 */

/* Shared palette. */
export const C = {
    blue: '#2563eb',
    ink: '#111827',
    mut: '#6b7280',
    line: '#e5e7eb',
    cup: '#eef6f0',
    green: '#5fa777',
    greenTxt: '#2f7d4f',
    selFill: '#eff6ff',
    item: '#b45309',
}

const DEFAULT_ITEM_COLOR = '#94a3b8'

/* Color per item type, used to render page items on cups + a legend. */
const ITEM_TYPE_COLORS: Record<string, string> = {
    ContextBox: '#7c3aed',
    Content: '#64748b',
    AudioEvaluation: '#d97706',
    AudioCheck: '#b45309',
    MultipleChoice: '#0d9488',
    SingleSelectCheckbox: '#0891b2',
    Rating: '#db2777',
    Likert: '#4f46e5',
    LikertStimulus: '#6366f1',
    LikertGroup: '#4338ca',
    RankingResponseTable: '#9333ea',
    Table: '#7c3aed',
    WritingExercise: '#16a34a',
    WrittenResponse: '#15803d',
    FreeText: '#65a30d',
    MediaStimulus: '#0284c7',
    StaticContentLayout: '#94a3b8',
}

export const colorForItemType = (type: string): string =>
    ITEM_TYPE_COLORS[type] ?? DEFAULT_ITEM_COLOR

/* Border color shared by all cups with the same (bucket rank, cup rank). */
const RANK_COLORS = [
    '#2563eb',
    '#16a34a',
    '#db2777',
    '#d97706',
    '#0d9488',
    '#7c3aed',
    '#dc2626',
    '#0891b2',
    '#65a30d',
    '#9333ea',
    '#ca8a04',
    '#4f46e5',
]

/** Deterministic color from (bucketRank, cupRank) via a simple string hash. */
export const rankColor = (bucketRank?: number, cupRank?: number): string => {
    const HASH_MULTIPLIER = 31
    const key = `${bucketRank ?? 0}-${cupRank ?? 0}`
    let h = 0
    for (let i = 0; i < key.length; i++) {
        h = (h * HASH_MULTIPLIER + key.charCodeAt(i)) >>> 0
    }
    return RANK_COLORS[h % RANK_COLORS.length]
}
